import { constants } from './constants';
import { IUnitSelectedDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory("machine-selected");

export const GetMachinesSelectedAction = actionCreator.async<{callCounter: number}, IUnitSelectedDto[]>(constants.GET_SELECTED_MACHINES);
